module.exports = __webpack_public_path__ + "static/img/reinforced-window_256.486a89b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/reinforced-window_256.png
// module id = drVv
// module chunks = 0